/** Tenant configuration for automatic fault conversion, separate from operational triage. */
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { useAuth } from "@/app/auth";
import { AutoConversionRules } from "@/features/requests/AutoConversionRules";
import { LoadingState, PageHeader } from "@/shared/components/page";

/** Only explicit automation managers may load or edit tenant conversion policy. */
export function FaultAutomationPage(): ReactElement {
  const { can, status } = useAuth();
  const { t } = useTranslation();
  if (status === "booting") return <LoadingState />;
  if (!can("requests.automation.manage")) {
    return <p role="alert">{t("requests.automationDenied")}</p>;
  }
  return (
    <div>
      <PageHeader title={t("requests.automationTitle")} />
      <p className="mb-4 text-sm text-muted-foreground">{t("requests.ruleExplanation")}</p>
      <AutoConversionRules />
    </div>
  );
}
